const messages = {
  title: 'Dirección de envío',
  appointmentTitle: 'Dirección de facturación',
}

export default messages
